<script setup>
import MechanicGrid from '@/components/registry/MechanicGrid.vue'
</script>
<template>
  <mechanic-grid />
</template>
